const apiUrl = process.env.REACT_APP_API_URL;
export const GetJutgeUsuariIdJavamons = async (id: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/usuaris/${id}/javamons`);
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('Error al obtener los datos:', error);
        return [];
    }
};
